export const sendGtagData = (...args) => {
  try {
    if (window.gtag) {
      window.gtag(...args);
    }
  } catch (error) {
    console.error(error);
  }
};
